/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';
	
	(function () {
	
		var HeaderNav = document.getElementById('st-header_nav');
		var HeaderFrag = false;
		var HeaderBtnOpen = document.getElementById('st-header_btn-open');
		var HeaderBtnClose = document.getElementById('st-header_btn-close');
	
		HeaderBtnOpen.addEventListener('click', function () {
			if (!HeaderFrag) {
				HeaderNav.className = 'st-header_nav st-header_nav-visible';
				HeaderFrag = true;
			}
		}, false);
	
		HeaderBtnClose.addEventListener('click', function () {
			if (HeaderFrag) {
				HeaderNav.className = 'st-header_nav st-header_nav-hidden';
				HeaderFrag = false;
			}
		}, false);
	
		var topBtn = document.getElementById('st-top');
	
		window.addEventListener('scroll', function () {
			if (window.pageYOffset > 100) {
				topBtn.className = 'st-top st-top-visible';
			} else {
				topBtn.className = 'st-top st-top-hidden';
			}
		}, false);
	
		$("a[href^=#]").on("click", function () {
			var linkSpeed = 800;
			var linkHref = $(this).attr("href");
			if (window.innerWidth > 768) {
				var headerHeight = 100;
			} else {
				var headerHeight = 0;
			}
	
			var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
			var linkPosition = linkTarget.offset().top - headerHeight;
			console.log(headerHeight);
			$("html, body").animate({ scrollTop: linkPosition }, linkSpeed, "swing");
	
			return false;
		});
	})();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js